import { Component, OnInit, HostListener, Input } from '@angular/core';
import { AuthService } from 'src/app/api/auth.service';
import { ProfileService } from 'src/app/api/profile.service';
import { User, TierLevel } from 'src/app/models/user';
import { environment } from 'src/environments/environment';
import { ThemeService } from 'src/app/services/theme.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss']
})
export class SiteHeaderComponent implements OnInit {
  @Input() logo = 'assets/images/logo-white.svg';

  links = environment.links;
  menuOpened = false;
  user: User;
  sticky = false;
  isArabic = false;
  isDarkMode = false;

  constructor(
    private auth: AuthService,
    private profileService: ProfileService,
    private localeService: LocaleService,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    this.isArabic = this.localeService.isArabic();
    this.isDarkMode = this.themeService.isDarkTheme;
    if (this.isLoggedIn()) {
      this.getProfile();
    }
  }

  getProfile() {
    this.profileService.getGeneral().subscribe(data => {
      this.user = data;
    });
  }

  toggleMenu() {
    this.menuOpened = !this.menuOpened;

    if (this.menuOpened) {
      window.document.body.classList.add('noscroll');
    } else {
      window.document.body.classList.remove('noscroll');
    }
  }

  isLoggedIn() {
    return this.auth.getToken();
  }

  isVerified() {
    return this.user && this.user.verificationDetails && this.user.verificationDetails.tier !== TierLevel.NONE;
  }

  getArLink() {
    return window.location.href.replace('/en/', '/ar/');
  }

  getEnLink() {
    return window.location.href.replace('/ar/', '/en/');
  }

  @HostListener('window:scroll')
  onScroll() {
    if (window.scrollY > 100) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }
  }
}
